import moment from 'moment'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        // Date format filter
        Vue.filter('date', function (value, format = 'DD / MM / YYYY') {
            if (value) {
                return moment(String(value)).format(format);
            }
        });

    }
}
